<!--Report 및 Schedule에서 Email 받을 사용자 검색시 사용-->
<!--TODO :: OpsNow 3.0 적용하여 multiselect 될때 여기 수정 필요-->

<template>
    <div class="wrap-label">

        <div class="inner">
            <div class="button-ui general border small fill color" data-fill="skyblue" data-border="skyblue" data-color="blue"
                v-for="item of receiverList">
                {{item.userEmail}}
                <button class="general after" data-icon="close" data-icon-color="blue" v-on:click="deleteReceiver(item)"></button>
            </div>
        </div>

        <input type="text" id="" name="" placeholder="abc@abc.com"
               v-bind="inputEmailStr" v-on:keyup.13="addReceiver($event)">
        <p class="invalid-message" v-if="invalidEmail">{{invalidMsg}}</p>

        <!--<input type="text" id="inputname" name="" placeholder="이름을 입력해주세요." onkeydown="JavaScript:enterCheck(this,'#popup-settings');">-->
    </div>
    <!--<p class="invalid-message">error message</p>-->

</template>

<script>
    export default {
        name: 'searchEmailUser',
        data() {
            return {
                inputEmailStr:"",
                receiverList:[],
                invalidEmail : false,
                invalidMsg : null
            }
        },

        methods : {
            addReceiver(event){
                let emailStr = event.target.value

                // email 형식에 맞지 않는 경우
                if(this.Common.isInvalidEmail(emailStr)){
                    this.invalidEmail = true;
                    this.invalidMsg = this.$t('COMMON.SEARCH.INVALID_EMAIL');
                    return;
                }else{
                    let user = {
                        userEmail : emailStr
                    }
                    this.receiverList.push(user)
                    this.invalidEmail = false;
                    event.target.value = '';
                }
            },
            deleteReceiver(receiver){
                this.receiverList = _.remove(this.receiverList, receiver)
            },
            returnReceiver(){
                if(this.receiverList.length == 0){
                    this.invalidEmail = true;
                    this.invalidMsg = this.$t('COMMON.SEARCH.EMPTY_USER_NAME');
                 return;
                }else{
                    this.invalidEmail = false;
                }
                return this.receiverList
            },
            closePopup(){
                this.receiverList=[];
                this.invalidEmail = false;
                this.Common.closePopup();
            },
        },

        mounted() {
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/common/searchEmailUser.vue